module.exports = "<router-outlet> </router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Проекты/grant_results/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main